import * as React from 'react';
import { isEqual } from '@lib/index';
import '@style/component/editable-text.less';

export interface EditableTextPropsInfo {
  text: string;
  placeholder?: string;
  onChanged?: (text: string) => void;
  onBlur?: (text: string) => void;
}

export interface EditableTextStateInfo { }

export class EditableText extends React.Component<
  EditableTextPropsInfo,
  EditableTextStateInfo
  > {
  divRef: any;
  constructor(props: EditableTextPropsInfo) {
    super(props);
  }

  handleChange = (text: string) => {
    const { onChanged } = this.props;

    if (onChanged) {
      onChanged(text);
    }
  };

  handleBlur = (text: string) => {
    const { onBlur } = this.props;

    if (onBlur) {
      onBlur(text);
    }
  };

  componentDidMount() {
    if (this.props.text !== this.divRef.innerText) {
      this.divRef.innerText = this.props.text;
    }
  }

  shouldComponentUpdate(nextProps: any, nextState: any, nextContext: any) {
    if (nextProps.text !== this.divRef.innerText) {
      this.divRef.innerText = nextProps.text;
      return true;
    }

    return !isEqual(this.state, nextState) || !isEqual(this.props, nextProps);
  }

  render() {
    const { text, placeholder } = this.props;

    return (
      <div
        ref={(divRef: any) => {
          this.divRef = divRef;
        }}
        className="editable-text"
        dangerouslySetInnerHTML={{ __html: text }}
        contentEditable={true}
        placeholder={placeholder || ''}
        onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) => {
          if (event.which === 13) {
            event.preventDefault();
          }
        }}
        onInput={(event: React.FormEvent<HTMLDivElement>) =>
          this.handleChange(event.currentTarget.innerText)
        }
        onBlur={(event: React.FormEvent<HTMLDivElement>) =>
          this.handleBlur(event.currentTarget.innerText)
        }
      />
    );
  }
}
